(() => {
  const unhideParent = (elem) => {
    const id = elem.getAttribute('id');
    const hiddenParent = elem.parentElement.closest('[aria-hidden="true"]');

    if (id) {
      const toggle = window.swinger.$(`[href="#${id}"]`)[0];

      if (toggle) {
        window.setTimeout(() => {
          toggle.click();
        }, 200);
      }
    }

    if (!hiddenParent) {
      return;
    }

    unhideParent(hiddenParent);
  };

  const unhideTarget = () => {
    const hash = window.location.hash;

    if (!hash) {
      return;
    }

    const elem = window.swinger.$(`${hash}`)[0];

    if (!elem) {
      return;
    }

    const hiddenParent = elem.closest('[aria-hidden="true"]');

    if (!hiddenParent) {
      return;
    }

    unhideParent(hiddenParent);
    window.requestAnimationFrame(() => {
      elem.focus({ preventScroll: true });
      elem.scrollIntoView({ behavior: 'smooth' });
    });
  };

  window.addEventListener('hashchange', unhideTarget);

  document.addEventListener('animationstart', (e) => {
    if (e.animationName !== 'swinger-target') {
      return;
    }

    const elem = window.swinger.eventHub.getTarget(e);

    (document.scrollingElement || document.body).scrollTo(0, elem.getBoundingClientRect().top - 100);
  });

  unhideTarget();
})();
